import type { BaseCaseMonthVO } from '../../saber.types'

// Client-side CSV export of the base case monthly rows (v001 §10 Export button).

const HEADERS = [
  'month',
  'contractYear',
  'modeledKwh',
  'modeledRevenue',
  'netRevenue',
  'accRate',
  'actualKwh',
  'actualRevenue',
  'status'
] as const

const cell = (value: string | number | null): string => {
  if (value == null) return ''
  const s = String(value)
  return /[",\n]/.test(s) ? `"${s.replaceAll('"', '""')}"` : s
}

/** Render the months array as a CSV string (header row + one row per month). */
export const monthsToCsv = (months: BaseCaseMonthVO[]): string =>
  [HEADERS.join(','), ...months.map((m) => HEADERS.map((h) => cell(m[h])).join(','))].join('\n')

/** Trigger a client-side download of a CSV string. */
export const downloadCsv = (filename: string, csv: string): void => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}
